// The agent form has one calendar field; scheduling profiles carry this prefix, external calendars are plain IDs.
export const SCHEDULING_PREFIX = 'scheduling:';

export const isSchedulingSelection = (value: string | null | undefined): boolean =>
  !!value && value.startsWith(SCHEDULING_PREFIX);

export const schedulingSelection = (profileId: string): string => `${SCHEDULING_PREFIX}${profileId}`;

// The backend rejects agents with both relations, so exactly one list is filled.
export const toAgentCalendarRelations = (
  value: string | null | undefined
): { calendars: string[]; scheduling_profiles: string[] } => {
  if (!value) return { calendars: [], scheduling_profiles: [] };
  if (isSchedulingSelection(value)) {
    return { calendars: [], scheduling_profiles: [value.slice(SCHEDULING_PREFIX.length)] };
  }
  return { calendars: [value], scheduling_profiles: [] };
};

type RelationItem = string | { id: string };

const idOf = (item: RelationItem): string => (typeof item === 'string' ? item : item.id);

export const fromAgentCalendarRelations = (
  calendars?: RelationItem[] | null,
  schedulingProfiles?: RelationItem[] | null
): string => {
  if (Array.isArray(schedulingProfiles) && schedulingProfiles.length > 0) {
    return schedulingSelection(idOf(schedulingProfiles[0]));
  }
  if (Array.isArray(calendars) && calendars.length > 0) return idOf(calendars[0]);
  return '';
};
